import { render, staticRenderFns } from "./Fish.vue?vue&type=template&id=14b652b1&"
import script from "./Fish.vue?vue&type=script&lang=js&"
export * from "./Fish.vue?vue&type=script&lang=js&"
import style0 from "./Fish.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports